import { Pipe, PipeTransform, LOCALE_ID, Inject } from '@angular/core';
import { CalendarDateFormatter } from './../providers/calendarDateFormatter.provider';


export class CalendarDate implements PipeTransform {

  constructor(private dateFormatter: CalendarDateFormatter,  private locale: string) {}

  transform(date: Date, method: string, locale: string = this.locale): string {
    return this.dateFormatter[method]({date, locale});
  }

static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'calendarDate'
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
{type: CalendarDateFormatter, },
{type: undefined, decorators: [{ type: Inject, args: [LOCALE_ID, ] }, ]},
];
}
interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
